export const USER_LOCALE = 'userLocale';

export default { USER_LOCALE };
